import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const FooterContainer = styled.footer`
  background: transparent;
  border-top: 1px solid ${theme.colors.border};
  padding: ${theme.spacing.xl} ${theme.spacing.md};
  padding-bottom: calc(${theme.spacing.xl} + env(safe-area-inset-bottom, 0px));
  margin-top: auto;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: ${theme.spacing.lg} ${theme.spacing.md};
    padding-bottom: calc(${theme.spacing.lg} + env(safe-area-inset-bottom, 0px));
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.lg};
`;

const FooterLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.xl};
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    gap: ${theme.spacing.md};
  }
`;

const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: ${theme.typography.fontSizes.sm};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  &:hover {
    color: ${theme.colors.primary};
    transform: translateY(-2px);
  }

  &::before {
    content: '🔗';
    font-size: 0.9rem;
  }
`;

const Copyright = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: ${theme.typography.fontSizes.xs};
  text-align: center;
  padding-top: ${theme.spacing.md};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
  
  a {
    color: rgba(255, 215, 0, 0.8);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: rgba(255, 215, 0, 1);
    }
  }
`;

const FooterLogo = styled.div`
  font-size: ${theme.typography.fontSizes.xl};
  font-weight: ${theme.typography.fontWeights.bold};
  background: ${theme.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: ${theme.spacing.sm};
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>GG TROPHY</FooterLogo>
        <FooterLinks>
          <FooterLink href="https://aaaconsultingco.com" target="_blank" rel="noopener noreferrer">
            Good Games Technologies.
          </FooterLink>
          <FooterLink href="https://aaaconsultingco.com/about" target="_blank" rel="noopener noreferrer">
            About Us
          </FooterLink>
          <FooterLink href="https://aaaconsultingco.com/contact" target="_blank" rel="noopener noreferrer">
            Contact
          </FooterLink>
        </FooterLinks>
        <Copyright>
          © {new Date().getFullYear()} GG Trophy. All rights reserved. Powered by <a href="https://aaaconsultingco.com" target="_blank" rel="noopener noreferrer">Good Games Technologies</a>
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
